import React, { FC } from 'react';
import { TableSettingsButtonsProps } from './TableSettingsButtonsProps';
import IngkaTooltip from '../IngkaTooltip';
import Button from '@ingka/button';
import reloadIcon from '@ingka/ssr-icon/paths/circlepath-two-triangles';
import saveIcon from '@ingka/ssr-icon/paths/folder';

const TableSettingsButtons: FC<TableSettingsButtonsProps> = ({
  saveSettings,
  resetSettings,
}) => {
  return (
    <>
      <IngkaTooltip label={'Save Settings'}>
        <Button
          iconOnly
          ssrIcon={saveIcon}
          size={'small'}
          type={'tertiary'}
          onClick={saveSettings}
        />
      </IngkaTooltip>
      <IngkaTooltip label={'Reset settings'}>
        <Button
          iconOnly
          ssrIcon={reloadIcon}
          size={'small'}
          type={'tertiary'}
          onClick={resetSettings}
        />
      </IngkaTooltip>
    </>
  );
};

export default TableSettingsButtons;
